<template>
  <div class="filter-countries">
    <el-input v-model="input" :placeholder="`Search within ${region.name}`" />
    <div
      v-for="item in countriesList"
      :key="item.tid"
      class="jurisdictions__country-six"
      :class="{ full: item.nestedChildren && item.nestedChildren.length }"
    >
      <CountryWithPopover
        :name="item.name"
        :tid="item.tid"
        :hub="item.huburl"
        :reports="item.reports"
        :flag="item.flagurl"
        :subscribed="item.subscribed"
        :class="{ transparent: currentTid && currentTid !== item.tid }"
        @popOverChange="selectPopover"/>
    </div>
  </div>
</template>

<script>
import { url } from "../../mixin/url";
export default {
  name: "FilterCountry",
  components: {
    CountryWithPopover: () => import("../elements/CountryWithPopover.vue"),
  },
  mixins: [url],
  props: {
    region: {
      type: [Array, Object],
      default: null,
    },
    currentTid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  computed: {
    countriesList() {
      let filtered = [];
      if (this.input) {
        filtered = this.region.children.filter(
          (item2) =>
            item2.name.toLowerCase().indexOf(this.input.toLowerCase()) === 0
        );
      } else {
        filtered = this.region.children;
      }
      return filtered;
    },
  },
  methods: {
    selectPopover(id) {
      this.$emit("popOverChange", id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/helpers/variables";
@import "@/assets/styles/helpers/mixin";
.filter-countries {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .el-input {
    margin-bottom: 2rem;
    input {
      border-radius: 0;
      border: 1px solid rgba(198, 214, 227, 0.5);
      height: 4rem;
      line-height: 4rem;
    }
  }
}

.jurisdictions__country {
  display: flex;
  flex-direction: row;
  padding: 1rem;
  align-items: center;
}

.jurisdictions__country-six {
    width: calc(100% / 6);
    padding: 2rem;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

.full {
  width: 100%;
}

.transparent {
  opacity: 0.25;
}
</style>
